export const getResource = (key: string) => {
  const r: Record<string, string> = {
    'Page.Main.Title': 'Toda a programação dos canais MEO',
    'Page.Main.Subtitle':
      'Nunca percas os teus programas favoritos. Vê, consulta e agenda gravações. Tudo online',
    'Page.Recordings.Title': 'Gravações agendadas',
    'Page.Recordings.Description':
      'Tem outra Box?  <a><u> Gravar numa box diferente</u></a>',
    'Program.Drawer.Today': 'Hoje',
    'Program.Drawer.Record.Description':
      'Tem outra Box? <u> Gravar numa box diferente</u>',
    'Program.Drawer.Box': 'Gravar numa box diferente',
    'Program.Drawer.OtherEpisodes': 'Outros episódios',
    'Program.Drawer.OtherSchedules': 'Outros horários',
    'Program.CheckDetail': 'Ver detalhe do programa',
    'Program.EpisodeAbbreviation': 'Ep.',
    'Login.Title':
      'Quer gravar este programa ou rever uma gravação automática?',
    'Login.Subtitle': 'Faça login com o seu',
    'Login.IDMEO': 'ID MEO',
    'Program.Next': 'Próximo programa na série',
    'Program.Previous': 'Programa anterior na série',
    'Program.RecordProgram': 'Gravar Programa',
    'Program.RecordSeries': 'Gravar Série',
    'Program.RecordCancel': 'Cancelar Gravação',
    'ChannelProgramming.Error':
      'Ocorreu um erro ao carregar a programação do canal.',
    'Grid.Select.Placeholder': 'Selecionar um dia',
    'Program.AdultContent': 'Conteúdo Adulto',
    'ChannelModal.Title': 'Todos os canais',
    'ProgramCard.Now': 'Agora',
    'ProgramCard.SeeMore': 'Ver mais',
    'ProgramDetail.KnowChannel': 'Conhecer canal',
    'ChannelPage.Now': 'Agora',
    TVGuide: 'Guia TV',
    'Search.NoResults.Title': 'Não foram encontrados resultados',
    'Search.NoResults.Description': 'Refina a tua pesquisa e tenta novamente',
    'Search.Loading': 'A carregar mais programas...',
    Edit: 'Editar',
    AutomaticRecordings: 'Gravações automáticas',
    'UserRecordings.NoAuth.Title': 'Quer ver as suas gravações?',
    'UserRecordings.NoRecordings.Title': 'Não tem gravações agendadas',
    'UserRecordings.NoRecordings.Description':
      'Agende as suas gravações para não perder os seus programas favoritos.',
  }

  return (
    window.ISites.Utils.Resources.getResourceFromList('GridTVResources', key) ||
    r[key] ||
    '--'
  )
}
